import React, { useState, useEffect } from 'react';

interface ProfileAvatarProps {
  logoUrl?: string | null;
  fallbackName?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export default function ProfileAvatar({
  logoUrl,
  fallbackName = '',
  className = '',
  size = 'md',
}: ProfileAvatarProps) {
  const [hasError, setHasError] = useState(false);

  const cleanUrl = (logoUrl || '').replace(/"/g, '').trim();

  useEffect(() => {
    setHasError(false);
  }, [cleanUrl]);

  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-9 h-9 text-sm',
    lg: 'w-10 h-10 text-base',
  }[size];

  const initial = (fallbackName || 'B').charAt(0).toUpperCase();

  if (cleanUrl && !hasError) {
    return (
      <div
        className={`${sizeClasses} rounded-full overflow-hidden bg-white border border-slate-200 flex items-center justify-center p-0.5 flex-shrink-0 ${className}`}
      >
        <img
          src={cleanUrl}
          alt="Business Logo"
          className="w-full h-full object-contain"
          onError={() => setHasError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`${sizeClasses} rounded-full bg-teal-100 text-teal-700 font-bold flex items-center justify-center flex-shrink-0 ${className}`}
    >
      {initial}
    </div>
  );
}
